export const maintenanceServiceTypes = [
  "Oil Change",
  "Tire Service",
  "Brake Service",
  "Fluid Service",
  "Spark Plugs",
  "Engine Air Filter",
  "Other"
];

export const performedByOptions = [
  "Owner",
  "Independent Shop",
  "Dealership",
  "Other"
];

export const createEmptyPart = () => ({
  id: `part-${Date.now()}-${Math.random().toString(36).slice(2)}`,
  partName: "",
  brand: "",
  partNumber: "",
  cost: ""
});

export const inferPartCategory = (serviceType = "", partName = "") => {
  const name = partName.toLowerCase();
  const service = serviceType.toLowerCase();

  if (
    name.includes("oil") ||
    name.includes("coolant") ||
    name.includes("fluid") ||
    name.includes("transmission") ||
    name.includes("differential") ||
    name.includes("power steering")
  ) {
    return name.includes("filter") ? "Filters" : "Fluids";
  }

  if (name.includes("filter")) return "Filters";

  if (
    name.includes("brake") ||
    name.includes("pad") ||
    name.includes("rotor") ||
    name.includes("line")
  ) {
    return "Brakes";
  }

  if (name.includes("spark") || name.includes("ignition") || name.includes("coil")) {
    return "Ignition";
  }

  if (name.includes("tire") || name.includes("valve stem") || name.includes("tpms")) {
    return "Tires";
  }

  if (name.includes("engine")) return "Engine";

  if (service.includes("brake")) return "Brakes";
  if (service.includes("tire")) return "Tires";
  if (service.includes("spark")) return "Ignition";
  if (service.includes("fluid") || service.includes("oil")) return "Fluids";
  if (service.includes("filter")) return "Filters";

  return "Other";
};

const toNumberOrNull = (value) => {
  if (value === "" || value === null || value === undefined) return null;

  const numberValue = Number(value);

  if (Number.isNaN(numberValue)) return null;

  return numberValue;
};

export const normalizePartsUsed = (partsUsed = [], serviceType = "") => {
  const errors = [];

  const normalizedParts = partsUsed
    .map((part) => {
      const partName = (part.partName || part.part || "").trim();
      const brand = (part.brand || part.partBrand || "").trim();
      const partNumber = (part.partNumber || "").trim();
      const cost = toNumberOrNull(part.cost);

      const hasAnyValue =
        partName ||
        brand ||
        partNumber ||
        part.cost !== "" && part.cost !== null && part.cost !== undefined;

      if (!hasAnyValue) return null;

      if (!partName) {
        errors.push("Part name is required when a part row has brand, part number, or cost.");
        return null;
      }

      if (cost !== null && cost < 0) {
        errors.push("Part cost cannot be negative.");
        return null;
      }

      return {
        id: part.id || `part-${Date.now()}-${Math.random().toString(36).slice(2)}`,
        partName,
        brand: brand || null,
        partNumber: partNumber || null,
        cost,
        category: inferPartCategory(serviceType, partName)
      };
    })
    .filter(Boolean);

  return {
    partsUsed: normalizedParts,
    errors
  };
};

export const normalizeMaintenanceEntry = (entry = {}) => {
  const serviceType = entry.serviceType || "Maintenance";
  const rawParts =
    Array.isArray(entry.partsUsed) && entry.partsUsed.length > 0
      ? entry.partsUsed
      : [
          {
            id: entry.partId,
            partName: entry.partName || entry.part || "",
            brand: entry.brand || entry.partBrand || "",
            partNumber: entry.partNumber || "",
            cost: entry.cost ?? ""
          }
        ];

  const { partsUsed } = normalizePartsUsed(rawParts, serviceType);

  return {
    id: entry.id,
    serviceType,
    serviceDate: entry.serviceDate || entry.date || "",
    mileage: entry.mileage ?? "",
    partsUsed,
    totalCost: entry.totalCost ?? entry.cost ?? null,
    partsCost: entry.partsCost ?? null,
    laborCost: entry.laborCost ?? null,
    serviceProvider: entry.serviceProvider || entry.shopName || null,
    performedBy: entry.performedBy || "Owner",
    nextServiceMileage: entry.nextServiceMileage ?? null,
    nextServiceDate: entry.nextServiceDate || "",
    receiptUrl: entry.receiptUrl || "",
    notes: entry.notes || "",
    createdAt: entry.createdAt || null,
    updatedAt: entry.updatedAt || null
  };
};

export const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "") return "";

  const numberValue = Number(value);

  if (Number.isNaN(numberValue)) return "";

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  }).format(numberValue);
};

export const formatMileage = (value) => {
  if (value === null || value === undefined || value === "") return "";

  const numberValue = Number(value);

  if (Number.isNaN(numberValue)) return "";

  return `${numberValue.toLocaleString()} mi`;
};

export const formatMaintenanceDate = (value) => {
  if (!value) return "";

  const date = new Date(`${value}T00:00:00`);

  if (Number.isNaN(date.getTime())) return value;

  return date.toLocaleDateString();
};